angular.module('autoremind.dashboard.directives')
    .directive('supportWidget', ['$location', function ($location) {
        return {
            templateUrl: 'app/dashboard/widgets/support/support.html',
            scope: true,
            link: function (scope, elem, attr) {
            }
        };
    }]);
//# sourceMappingURL=support.directive.js.map